;(function () {
  angular
    .module('contrast.vulnerabilities')
    .directive('traceStatus', function (CLOSED_STATUS) {
      'ngInject'

      return {
        restrict: 'A',
        scope: {
          status: '='
        },
        link: function (scope, element) {
          if (_.indexOf(CLOSED_STATUS, scope.status) != -1) {
            element.addClass('light-gray')
          }
        }
      }
    })
})()
